import { Dispatch, SetStateAction } from 'react';
import { Admission, AdmissionType } from '@domain/admission';
import { Event } from '@domain/event';
import { FormFieldPresets } from '@domain/form-field-presets';
import { CreateAdmissionRequest } from '@hooks/admissions/type';

export const ADMISSION_MODAL_STEP_ADMISSION_TYPE = 'admissionType';
export const ADMISSION_MODAL_STEP_TICKET = 'ticket';
export const ADMISSION_MODAL_STEP_GUEST_LIST = 'guestList';
export const ADMISSION_MODAL_STEP_BOTTLE_SERVICE = 'bottleService';

export type AdmissionModalStep =
  | typeof ADMISSION_MODAL_STEP_ADMISSION_TYPE
  | typeof ADMISSION_MODAL_STEP_BOTTLE_SERVICE
  | typeof ADMISSION_MODAL_STEP_GUEST_LIST
  | typeof ADMISSION_MODAL_STEP_TICKET;

export const ADMISSION_MODAL_STEP_ADMISSION_TYPE_TEST_ID = 'admission-modal--step-admission-type';
export const ADMISSION_MODAL_STEP_ADMISSION_TICKET_TEST_ID = 'admission-modal--step-admission-ticket';
export const ADMISSION_MODAL_STEP_ADMISSION_GUEST_LIST_TEST_ID = 'admission-modal--step-admission-guest-list';
export const ADMISSION_MODAL_STEP_ADMISSION_BOTTLE_SERVICE_TEST_ID = 'admission-modal--step-admission-bottle-service';

export interface AdmissionModalProps {
  isOpen: boolean;
  handleClose: () => void;
  event: Event;
  handleSubmit: (ticket: CreateAdmissionRequest, type: AdmissionType) => void;
  formFieldsPresets: FormFieldPresets;
  offer?: Admission | null;
  offerType?: AdmissionType | null;
  afterOfferDescription?: string;
  onDeleteOffer?: () => void;
  onHideOffer?: () => void;
  isCreatedFromPreset?: boolean;
  handleSaveConfirmModal: () => void;
  handleCloseConfirmModal: () => void;
  isConfirmModalOpen?: boolean;
  setActiveConfirmModal?: Dispatch<SetStateAction<boolean>>;
  isDuplicatedAdmission?: boolean;
  ddpPreset?: number;
}
